// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"8beb6293","239":"d9f65f00","453":"4437eca8","455":"aa0b09a2","977":"9818c314"}[chunkId] + ".chunk.js";
};